<ng-template #content let-modal>
  <div
    class="modal-header"
    style="
      background: linear-gradient(to bottom, #f9f9fc 0%, #eeeef4 100%);
      height: 50px;
      width: 760;
    "
  >
    <h4 style="font-size: 16px; font-weight: 500" class="modal-title ml-0">
      Language
    </h4>
    <button
      type="button"
      aria-label="Close"
      class="button-close"
      (click)="closeModal()"
      style="
        border: none;
        background: linear-gradient(to bottom, #f9f9fc 0%, #eeeef4 100%);
      "
    >
      <span aria-hidden="true" style="font-size: 30px"> &times; </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="lang">
      <div class="d-flex mt-5 mx-5" style="justify-content: space-between">
        <h3 style="font-size: 20px; font-weight: 500">Select Language</h3>
        <span class="text-right save" id="labguageFileText">
          <i
            *ngIf="labguageFileText"
            class="fas fa-check-circle"
            style="color: green"
          ></i
          >{{ labguageFileText }}
        </span>
      </div>

      <div class="menu-container mx-5 mt-2 mb-5">
        <button class="menu-btn mb-2" (click)="toggleMenu()">
          <img
            [src]="selectedLanguage.icon"
            alt="Selected language icon "
            class="me-2"
          />
          {{ selectedLanguage.name }}
          <img
            src="../../assets/images/arrow.svg"
            alt="nav-dropdown"
            (click)="toggleMenu()"
          />
        </button>

        <div
          id="menuContent"
          class="menu-content"
          [ngClass]="{ 'show-menu': isMenuOpen }"
        >
          <a
            *ngFor="let lang of languages"
            class="dropdown-item"
            href="javascript:void(0)"
            (click)="selectLanguage(lang)"
          >
            <img [src]="lang.icon" alt="drop-img" class="flag me-2" />
            <span>{{ lang.name }}</span>
          </a>
        </div>
      </div>

      <div *ngIf="isEnglishVariantSelected()">
        <div class="col-lg-12 col-md-11 col-10 mx-5 mt-2">
          <span
            class="text-justify mt-5"
            style="font-size: 20px; font-weight: 500; line-height: 24.2px"
            >What is the basic difference b/w British & American English?</span
          >
          <div style="display: flex; flex-direction: column" class="">
            <span
              class="text-justify"
              style="width: 573px; text-align: center"
              style="font-size: 15px; font-weight: 400; line-height: 31px"
            >
              <img
                src="/../../assets/images/account setting/check.svg"
                class="me-2"
              />
              British and American English have some spelling differences.
            </span>
            <span
              style="width: 573px; text-align: center"
              style="font-size: 15px; font-weight: 400"
            >
              <img
                src="/../../assets/images/account setting/check.svg"
                class="me-2"
              />The common ones are presented below.
            </span>
          </div>
        </div>
        <div class="col-12 flex mt-5 mx-5">
          <div class="col-lg-6 col-md-6">
            <span
              class="modal_text_med pb-2"
              style="font-size: 20px; font-weight: 500"
            >
              <img
                src="/../../assets/images/account setting/American.svg"
                class="me-2"
              />American</span
            >
            <div class="language_keywords mt-3">
              <span class="liss keyword-width"
                >-e- (e.g. anemia, diarrhea, encyclopedia)</span
              >

              <span class="lis">-ed (e.g. burned, dreamed, leaped)</span>

              <span class="liss">-ense (defense, offense, license)</span>

              <span class="lis">-el- (e.g. canceled, jeweler, marvelous)</span>

              <span class="liss"
                >-ize (e.g. appetizer, familiarize, organize)</span
              >

              <span class="lis">-ll- (e.g. enroll, fulfill, skillfull)</span>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 words">
            <span
              class="modal_text_med pb-2"
              style="font-size: 20px; font-weight: 500"
            >
              <img
                src="/../../assets/images/account setting/British.svg"
                class="me-2"
              />British</span
            >
            <div class="language_keywords mt-3">
              <span class="liss cls-768"
                >-oe-/-ae- (e.g. anaemia, diarrhoea, encyclopaedia)
              </span>

              <span class="lis">-t (e.g. burnt, dreamt, leapt)</span>

              <span class="lis">-ence (e.g. defence, offence, licence)</span>

              <span class="lis"
                >-ell- (e.g. cancelled, jeweller, marvellous)</span
              >

              <span class="liss"
                >-ise (e.g. appetiser, familiarise, organise)</span
              >

              <span class="lis">-l- (e.g. enrol, fulfil, skilful)</span>
            </div>
          </div>
        </div>

        <div [ngClass]="{ 'gradient-background': !showAll }">
          <div class="col-lg-12 col-md-11 col-10 mt-5 mx-5">
            <div>
              <h3
                style="font-size: 20px; font-weight: 500"
                [ngClass]="{ 'opacity-h3': !showAll }"
              >
                <img
                  src="/../../assets/images/account setting/Canadian.svg"
                  class="me-2 ms-1"
                />
                Canadian
              </h3>
              <span class="mid" [ngClass]="{ 'opacity-span': !showAll }">
                Candian English follows most British Spelling, grammar, and
                punctuation rules; so, most of the difference between British
                and Ameriacn English also apply to Canadian English.
              </span>
            </div>
            <div
              class="py-3 view-all"
              style="justify-content: center; display: flex"
            >
              <button
                class="view-all"
                (click)="showAll = true"
                *ngIf="!showAll"
              >
                View All
                <img
                  src="../../assets/images/arrow.svg"
                  alt="nav-dropdown"
                  class="ms-2"
                />
              </button>
            </div>
            <div *ngIf="showAll">
              <span class="mid">
                British, Canadian and Australisn English words with 'our' in
                them are spelt with 'or' in American English.
              </span>

              <ul class="english styled-list">
                <li class="d-flex">
                  <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                    British, Canadian :
                  </h5>
                  <span style="font-size: 16px; font-weight: 400"
                    >Color, Favourite</span
                  >
                </li>
                <li class="d-flex">
                  <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                    Australian:
                  </h5>
                  <span style="font-size: 16px; font-weight: 400"
                    >Color, Favourite</span
                  >
                </li>
                <li class="d-flex">
                  <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                    American:
                  </h5>
                  <span style="font-size: 16px; font-weight: 400"
                    >Color, Favourite</span
                  >
                </li>
              </ul>

              <div class="col-lg-12 my-5">
                <h3 style="font-size: 20px; font-weight: 500">
                  <img
                    src="/../../assets/images/account setting/Australian.svg"
                    class="me-2"
                  />Australia
                </h3>
                <span class="mid">
                  Australian English follows Brtish spelling very closely but
                  many common words are spelt differntly in American English;
                  such as those ending with 'yse' or 'ise'.
                </span>
                <ul class="english styled-list">
                  <li class="d-flex">
                    <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                      British and Australian:
                    </h5>
                    <span style="font-size: 16px; font-weight: 400"
                      >Analyse, Apologise</span
                    >
                  </li>
                  <li class="d-flex">
                    <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                      American:
                    </h5>
                    <span style="font-size: 16px; font-weight: 400"
                      >Analyse, Apologize
                    </span>
                  </li>
                </ul>
                <span class="mid">
                  British and Australian English words with 'our' in them are
                  spelt with 'or' in American English
                </span>
                <ul class="english styled-list">
                  <li class="d-flex">
                    <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                      British and Australian:
                    </h5>
                    <span style="font-size: 16px; font-weight: 400">
                      Colour, Favourite</span
                    >
                  </li>
                  <li class="d-flex">
                    <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                      American:
                    </h5>
                    <span style="font-size: 16px; font-weight: 400"
                      >Color, Favorite
                    </span>
                  </li>
                </ul>
                <span class="mid">
                  Words that end in '-re' in Austratian and British English are
                  spelt with '-er' in American English
                </span>
                <ul class="english styled-list">
                  <li class="d-flex">
                    <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                      British and Australian:
                    </h5>
                    <span style="font-size: 16px; font-weight: 400"
                      >Centre, Litre</span
                    >
                  </li>
                  <li class="d-flex">
                    <h5 style="font-size: 15px; font-weight: 600" class="mt-1">
                      American:
                    </h5>
                    <span style="font-size: 16px; font-weight: 400"
                      >Center, Liter
                    </span>
                  </li>
                </ul>
                <span class="mid">
                  There is exception in all verities, that contribute in their
                  similarities and differences with other varieties of language.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<button
  class="btn btn-lg btn-outline-primary d-none"
  (click)="openModels(content)"
>
  language
</button>
